<template>
  <v-app class="">
    <div class="max-height" style="display: flex;">
      <v-content>
        <v-container fluid pa-0 style="height: 100%; width: 100%; background-color: #092d49;">
          <v-layout justify-center fill-height>
            <v-flex lg10 class="flex-col mt-5 mb-auto">
              <v-img
                src="/static/logo.svg"
                height="4rem"
                contain
                style="margin-top: 12px">
              </v-img>
              <slot></slot>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </div>
  </v-app>
</template>
<script>
import AppMenu from "../Menu"
import Navbar from '../components/Navbar'

export default {
  name: 'BaseLeftBarLayout',
  components: {
    'app-menu': AppMenu,
    Navbar,
  },
  props: {},
  data(vm) {
    return {
      selected_language: vm.$root.lang,
      languages: [
        { code: 'pt', currency: 'BRL', display: 'Português' },
        { code: 'en', currency: 'USD', display: 'English' },
        { code: 'es', currency: 'MXN', display: 'Español' }
      ]
    }
  },
  methods: {
    i18n(str) {
      return this.$root.i18n[str] && this.$root.i18n[str][this.selected_language] || str
    },
    setLanguage() {
      this.$root.$emit('syncLang', this.selected_language)
      this.$forceUpdate()
    },
    triggerDownload() {
      this.$root.$emit('downloadReceipt')
    }
  },
  mounted() {

  }
}
</script>
<style>
  @import url("https://use.typekit.net/gbx5lto.css");
  
  .left-bar-layout {
    font-family: 'Paralucent';
  }

  .menu-background {
    background: #06233B !important;
    padding-top: 20px;
  }

  h1.max {
    font-family: 'Paralucent';
    color: #0C2E4A;
    font-size: 2.5rem;
  }

  .menu-min-width {
    width: 260px!important;
  }

  .download-btn {
    margin-left: auto;
    margin-right: auto;
    width: 80%;
  }

  .language-selector {
    margin-top: 84px;
    padding: 0 20px 0 20px;
  }

  .top-bar {
    background-color: white;
    display: flex;
    padding-right: 70px;
    padding-top: 24px;
    padding-bottom: 20px;
    margin-bottom: 18px;
  }

  body,
  div.max-height { height: 100%!important; position: relative!important; }

</style>



// WEBPACK FOOTER //
// src/layouts/BaseLayout.vue